export function DaySeparator({ label }: { label: string }) {
  return (
    <div className="flex items-center gap-3 py-2">
      <span className="h-px flex-1 bg-line-2" />
      <span className="text-[11px] font-medium text-ink-4">{label}</span>
      <span className="h-px flex-1 bg-line-2" />
    </div>
  )
}
